import { render, staticRenderFns } from "./ViewStandardisedJobCard.vue?vue&type=template&id=7a33dd0a&scoped=true"
import script from "./ViewStandardisedJobCard.vue?vue&type=script&lang=ts"
export * from "./ViewStandardisedJobCard.vue?vue&type=script&lang=ts"
import style0 from "./ViewStandardisedJobCard.vue?vue&type=style&index=0&id=7a33dd0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33dd0a",
  null
  
)

export default component.exports